import React from 'react';
import { Button, Input } from '@insly/qmt-reactjs-ui-lib';
import {
  AddPolicyDialog,
  AddPolicyDialogControlsButtons,
  AddPolicyDialogTitle,
  AddPolicyNumberWrapper,
  IconAdd
} from './styles';
import { translate } from 'utils';

type TAddPolicyNumber = {
  addPolicyNumber: (policyNumbers: string) => void,
};

const DIALOG_CLASS_NAME = 'add-policy-dialog-content--opened';
const DIALOG_BOTTOM_OFFSET = '46px';

export const AddPolicyNumber = ({ addPolicyNumber }: TAddPolicyNumber) => {

  const [isDialogOpen, setIsDialogOpen] = React.useState(false);
  const [policyNumber, setPolicyNumber] = React.useState('');

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
    setPolicyNumber('');
  };

  const handleAddPolicyNumber = () => {
    if (policyNumber.trim() !== '') {
      addPolicyNumber(policyNumber.trim());
      handleCloseDialog();
    }
  };

  //Close dialog on outside click
  React.useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (isDialogOpen && !target.closest(`.${DIALOG_CLASS_NAME}`)) {
        handleCloseDialog();
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };

  }, [isDialogOpen]);

  //Open dialog to top if page bottom will be overlapped
  React.useEffect(() => {
    if (isDialogOpen) {
      const dialogElement = document.querySelector(`.${DIALOG_CLASS_NAME}`) as HTMLElement;
      if (dialogElement) {
        const dialogRect = dialogElement.getBoundingClientRect();
        if (dialogRect.bottom > window.innerHeight) {
          dialogElement.style.bottom = DIALOG_BOTTOM_OFFSET;
        }
      }
    }
  }, [isDialogOpen]);


  return(
    <AddPolicyNumberWrapper>
      <Button preset="transparentBordered" onClick={isDialogOpen ? handleCloseDialog : handleOpenDialog}>
        <>
          <IconAdd icon="plus" />
          {translate({ key: 'idd.list.button.add_policy_number' })}&nbsp;
        </>
      </Button>
      <AddPolicyDialog isOpen={isDialogOpen} className={isDialogOpen ? DIALOG_CLASS_NAME: ''}>
        <AddPolicyDialogTitle>{translate({ key: 'idd.list.add_policy_number.title' })}</AddPolicyDialogTitle>
        <Input
          key="policyNumber"
          placeholder={translate({ key: 'idd.list.add_policy_number.input.placeholder' })}
          value={policyNumber}
          handleChange={(name, value) => setPolicyNumber(value as string)}
        />
        <AddPolicyDialogControlsButtons>
          <Button preset="secondary" onClick={handleCloseDialog}>{translate({ key: 'common.cancel' })}</Button>
          <Button onClick={handleAddPolicyNumber} disabled={policyNumber.trim() === ''}>{translate({ key: 'common.save' })}</Button>
        </AddPolicyDialogControlsButtons>
      </AddPolicyDialog>
    </AddPolicyNumberWrapper>
  );

};
